<ng-container *ngIf="table">
  <div class="table" [class.list-page]="isListPage" *ngIf="tableItems?.length > 0">
    <h2 [class.pharmacis-page-mobile-paddings]="isPharmacyPage">{{ tableHeading }}</h2>
    <div class="section header">
      <div class="left">Вид</div>
      <div class="right">{{ 'price' | transloco }}, грн</div>
    </div>
    <div *ngFor="let item of tableItems; let last = last;" class="section" [class.last-item]="last">
      <!-- Ссылки для перехода со страницы /list/:url на /info-drug -->
      <ng-container *ngIf="isListPage">
        <ng-container *ngIf="lang === 'ua'">
          <a class="left link" [routerLink]="'/ua/info-drug/' + item.url + '/' + item.id">{{ item.h1 }}</a>
        </ng-container>
        <ng-container *ngIf="lang === 'ru'">
          <a class="left link" [routerLink]="'/info-drug/' + item.url + '/' + item.id">{{ item.h1 }}</a>
        </ng-container>
        <div class="right price-range">{{ item.minPrice }} - {{ item.maxPrice }}</div>
      </ng-container>
      <!-- Ссылки для перехода со страницы /catalog/:url на /category/:url -->
      <ng-container *ngIf="isCatalogPage">
        <ng-container *ngIf="lang === 'ua'">
          <a class="left link" (click)="resetCategoryPage()" [routerLink]="'/ua/category/' + item.url">{{ item.h1 }}</a>
        </ng-container>
        <ng-container *ngIf="lang === 'ru'">
          <a class="left link" (click)="resetCategoryPage()" [routerLink]="'/category/' + item.url">{{ item.h1 }}</a>
        </ng-container>
        <div class="right price-range">{{ item.minPrice }} - {{ item.maxPrice }}</div>
      </ng-container>
      <!-- Без ссылок для страниц /pharmacies/:url и /preparat/:url/:town -->
      <ng-container *ngIf="isPharmacyPage || isPreparatPage">
        <p class="left link without-hover">
          <ng-cotainer *ngIf="isPharmacyPage">✅</ng-cotainer>
          <ng-cotainer *ngIf="isPreparatPage">⭕️</ng-cotainer>
          {{ item.itemName }}
        </p>
        <div class="right price-range">{{ item.itemValue }}</div>
      </ng-container>
    </div>
  </div>
</ng-container>